module.exports = __webpack_public_path__ + "static/media/PAI-diamond.e5aa8e69.svg";